import { lockScroll } from '@theme/utilities';

const CART_DRAWER_ID = 'cart-drawer';
const DESKTOP_QUERY = window.matchMedia('(min-width: 990px)');

function removePageSqueeze() {
  document.querySelector('.page-wrapper')?.classList.remove('page-wrapper--drawer-open');
}

function forceModalOverlay(panel) {
  if (!(panel instanceof HTMLDialogElement) || !panel.open || panel.matches(':modal')) return;

  panel.close();
  lockScroll(panel);
  panel.showModal();
}

function syncCartDrawerOverlay(drawer) {
  if (!(drawer instanceof HTMLElement) || drawer.id !== CART_DRAWER_ID || !drawer.hasAttribute('open')) {
    return;
  }

  removePageSqueeze();

  if (!DESKTOP_QUERY.matches) return;

  forceModalOverlay(drawer.querySelector('dialog'));
}

document.addEventListener('theme-drawer:open', (event) => {
  if (!(event.target instanceof HTMLElement) || event.target.id !== CART_DRAWER_ID) return;

  requestAnimationFrame(() => {
    syncCartDrawerOverlay(event.target);
  });
});

DESKTOP_QUERY.addEventListener('change', () => {
  syncCartDrawerOverlay(document.getElementById(CART_DRAWER_ID));
});

syncCartDrawerOverlay(document.getElementById(CART_DRAWER_ID));
